<template>
	<div class="proofOfWorkMainContainer" id="proofOfWorkMainContainer">
		<div class="proofOfWorkContainer">
			<div class="proofMainContainer">
				<div class="proofOfWorkImg">
					<img src="@/assets/images/proof-of-work.png" alt="" />
				</div>
			</div>
		</div>
	</div>
	<div class="proofMainContainer proofHeroCards">
		<div class="proofHeroHead">
			<h2>SECURING BLOCKCHAIN'S FUTURE</h2>
			<p>
Our cypherpunk-grounded, proof-of-work summit in Prague this fall was a smashing success. 
Our speakers and guests discussed Proof of Work and pushed back against the misleading mainstream narratives 
around PoW and focused on the fundamentals of this revolutionary freedom technology.
			</p>
		</div>

		<div class="row">
			<div class="col-lg-4 col-md-4 col-sm-6 col-12 px-md-3">
				<div class="heroCard">
					<div class="heroCardImg">
						<img src="@/assets/images/heroImg1-2023.png" alt="" />
					</div>
					<div class="heroCardContent">
						<h3>WORLD CLASS <span>SPEAKERS</span></h3>
						<p>
							Watch our video archive on our<a href="https://www.youtube.com/@POWSummit/"> YouTube channel</a> featuring Phil Zimmermann, Jameson Lopp, Charlie Lee, Caitlin Long & Jarrad Hope & more...
						</p>
					</div>
				</div>
			</div>
			<div class="col-lg-4 col-md-4 col-sm-6 col-12 px-md-3">
				<div class="heroCard">
					<div class="heroCardImg">
						<img src="@/assets/images/heroImg2-2023.png" alt="" />
					</div>
					<div class="heroCardContent">
						<h3>NETWORKING <span>OPPORTUNITIES</span></h3>
						<p>
							Meet & interact with speakers & guests at the conference or at our after-hours events. <a href="https://powsummit.com/photos">See our photos here.</a> 
						</p>
					</div>
				</div>
			</div>
			<div class="col-lg-4 col-md-4 col-sm-6 col-12 px-md-3">
				<div class="heroCard">
					<div class="heroCardImg">
						<img src="@/assets/images/heroImg3-2023.png" alt="" />
					</div>
					<div class="heroCardContent">
						<h3>HANDS-ON <span>WORKSHOPS</span></h3>
						<p>
							Learn & interact with the builders & developers themselves. Our <a href="https://www.youtube.com/playlist?list=PL6M4J55WQYzwnsF9O3NO8ujBcm_uavhP5">2023 workshops</a> are also available on our YouTube channel. 
						</p>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
